/* Copyright Verge Technologies 2018
 * @file downloadsPanel.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Component for displaying the description
 * panel on a product
 */

import React from 'react';
import PropTypes from 'prop-types';

const getIcon = (type) => {
  if (type === 'pdf') {
    return (
      <div className="icon">
        <svg width="75px" height="74px" viewBox="0 0 75 74">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(0.000000, 2.000000)">
              <polyline
                id="Path_687"
                stroke="#004DA9"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="56.793 62.195 12.084 62.195 12.084 27.01"
              />
              <path
                d="M66.104,9 L66.104,13"
                id="Line_117"
                stroke="#004DA9"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <polyline
                id="Path_688"
                stroke="#004DA9"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="12.084 10.875 12.084 0 56.793 0"
              />
              <rect
                id="Rectangle_1453"
                fill="#004DA9"
                fillRule="nonzero"
                x="0"
                y="10.875"
                width="33.052"
                height="16.206"
              />
              <polygon
                id="Path_689"
                fill="#004DA9"
                fillRule="nonzero"
                points="69.587 57.646 69.587 44.07 55.016 44.07 55.016 57.646 49.898 57.646 56.082 64.47 62.337 71.294 68.521 64.47 74.705 57.646"
              />
              <polygon
                id="Path_691"
                stroke="#004DA9"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="66.104 9.311 56.793 9.311 56.793 0"
              />
              <path
                d="M27.295,42.861 C26.6527452,43.222366 26.0353685,43.6262667 25.447,44.07 C23.954,45.136 21.747,46.7 21.111,48.477 C20.9227031,48.9549963 21.0039124,49.4971542 21.324,49.899 C21.6528152,50.2451214 22.1585973,50.3574295 22.603,50.183 C23.954,49.899 24.949,48.761 25.873,47.837 C31.773,41.937 35.473,34.047 37.673,26.087 C38.242,23.955 38.81,21.822 39.308,19.619 C39.7821724,18.0958723 40.0686247,16.5205528 40.161,14.928"
                id="Path_692"
                stroke="#004DA9"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M40.091,13.434 C40.0248819,12.9631634 39.8809179,12.5066014 39.665,12.083 C39.096,10.946 37.888,11.23 37.465,12.296 C37.2440598,12.9368774 37.1242909,13.608258 37.11,14.286 C37.104905,16.8059497 37.5355827,19.3078046 38.383,21.681 C38.525,22.036 38.596,22.392 38.738,22.747 C39.6933474,25.5212215 40.9332879,28.1891044 42.438,30.708 C44.1591617,33.6166458 46.6412874,36.0005791 49.617,37.603 C52.389,39.096 57.151,41.655 60.137,39.451 C60.5081807,39.2272578 60.7266807,38.8179064 60.706,38.385 C60.493,35.897 54.806,36.821 53.385,36.892 C49.831,36.963 46.277,37.532 42.723,37.958 C38.6803208,38.4179158 34.7273159,39.4701861 30.991,41.081"
                id="Path_693"
                stroke="#004DA9"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.444,17.13 C11.4943173,17.8915836 11.1772525,18.6312777 10.591,19.12 C9.9011703,19.6481151 9.03991273,19.9014681 8.174,19.831 L7.322,19.831 L7.322,22.959 L5.9,22.959 L5.9,14.642 L8.317,14.642 C9.14990322,14.5731021 9.98047033,14.7996848 10.663,15.282 C11.1857085,15.7508409 11.472056,16.4283956 11.444,17.13 Z M7.251,18.694 L7.962,18.694 C8.50594734,18.7204536 9.0467763,18.5976951 9.526,18.339 C9.82944819,18.0579973 10.0077459,17.6671907 10.0210861,17.2538321 C10.0344263,16.8404735 9.88169817,16.4389838 9.597,16.139 C9.19295745,15.8867009 8.72187889,15.7629164 8.246,15.784 L7.322,15.784 L7.322,18.698 L7.251,18.694 Z"
                id="Path_694"
                fill="#FDFEFF"
                fillRule="nonzero"
              />
              <path
                d="M19.903,18.694 C19.992227,19.8517634 19.5778454,20.9917684 18.766,21.822 C17.8526013,22.5827429 16.6822589,22.9642673 15.496,22.888 L13.15,22.888 L13.15,14.642 L15.709,14.642 C16.8506988,14.5764529 17.972927,14.9589002 18.837,15.708 C19.6137077,16.4984205 20.0035441,17.5904012 19.903,18.694 Z M18.481,18.765 C18.481,16.775 17.557,15.78 15.709,15.78 L14.501,15.78 L14.501,21.822 L15.501,21.822 C17.415,21.821 18.481,20.826 18.481,18.765 Z"
                id="Path_695"
                fill="#FDFEFF"
                fillRule="nonzero"
              />
              <polygon
                id="Path_696"
                fill="#FDFEFF"
                fillRule="nonzero"
                points="23.03 22.958 21.679 22.958 21.679 14.642 26.37 14.642 26.37 15.779 23.03 15.779 23.03 18.409 26.158 18.409 26.158 19.542 23.03 19.542"
              />
            </g>
          </g>
        </svg>
      </div>
    );
  }
};

const DownloadsPanel = (props) => {
  return (
    <div
      className="panels-page panels-downloads"
      style={{ display: props.activeToggle === 'DOWNLOADS' ? 'flex' : 'none' }}
    >
      <ul className="file-list">
        {props.downloads
          .filter(download => download.link && download.name && download.type)
          .map(download => (
            <li key={download.link}>
              <div className="description">
                {getIcon(download.type)}
                <div className="text">
                  {download.name}
                  <br />
                  {download.date}
                  <br />
                  <span>{(download.size / 1024).toFixed(2)} MB</span>
                </div>
              </div>
              <a href={download.link} className="download" download target="_blank">
                <svg width="47px" height="37px" viewBox="0 0 47 37">
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <g transform="translate(2.000000, 2.000000)" stroke="#81D34C" strokeWidth="4">
                      <polygon points="28.574 13.576 28.574 0 14.074 0 14.074 13.576 8.956 13.576 15.14 20.4 21.324 27.224 27.508 20.4 33.692 13.576" />
                      <polyline points="0 14.785 0 32.697 42.648 32.697 42.648 14.785" />
                    </g>
                  </g>
                </svg>
                <div className="text">Download</div>
              </a>
            </li>
          ))}
          {!props.downloads
            .filter(download => download.link && download.name && download.type).length && (
              <div className="message">No downloads available</div>
            )}
      </ul>
    </div>
  );
};

DownloadsPanel.propTypes = {
  activeToggle: PropTypes.string.isRequired,
  downloads: PropTypes.array.isRequired,
};

export default DownloadsPanel;



// WEBPACK FOOTER //
// ./src/components/DownloadsPanel/downloadsPanel.js